const GAP_SIZE = 16
const MIN_SIZE = 80
const MAX_SIZE = 160
const TABLET_BREAKPOINT = 768

export const calculateDragPreviewSize = (screenWidth: number): number => {
  const previewSize = Math.round(((screenWidth - 2 * GAP_SIZE) / 3) * (screenWidth >= TABLET_BREAKPOINT ? 0.7 : 0.925))
  return Math.max(MIN_SIZE, Math.min(MAX_SIZE, previewSize))
}

export const getInitialDragPreviewSize = (): number => calculateDragPreviewSize(window.innerWidth)
